<template>

<div class="custom-padding">
            <div class="container-fluid" v-for="item in items" :key="item.id">

                <div class="row">
                    <div class="col-md-12 pl-0 pr-0 mt-3">
                        <span class="heading-font-size"><i @click="backToStore()" class="fas fa-arrow-left mr-2"></i>{{storeName}}</span>
                            <img src="../assets/img/svg/Icon_awesome-check-circle.svg" class="img-fluid check-circle ml-3 mb-2" alt="Responsive image">
                    </div>
                    <div class="col-md-12 text-muted pl-0 pr-0">
                        <span class="comment-content">{{address}}</span>
                        <hr/>
                    </div>
                </div>

                <div class="row pb-3">
                    <div class="col">
                        <i class="fas fa-star custom-text-color mr-2"></i><b class="review-font-size">REVIEWS & RATINGS</b>
                    </div>
                    <div class="col">
                        <span class="custom-text-color float-right add-review cCursorhover"><a  class="review-font-size" data-toggle="modal" data-target="#reviewRating"><b><i class="fas fa-plus-circle mr-2"></i>Write a review</b></a></span>

                        

                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 top-rating-bar text-center p-3">
                        <span class="custom-text-color" v-for="stars in Math.floor(item[0].JSon0[0].AverageRating)" :key="stars.id">
                            <i class="fa fa-2x fas fa-star mr-2"></i>
                        </span>
                        <span class="custom-text-color" v-if="(item[0].JSon0[0].AverageRating % 1) != 0">
                            <i class="fa fa-2x fas fa-star-half mr-2"></i>
                        </span>
                        <span class="mr-3">
                            <b class="count-rating mr-2">{{item[0].JSon0[0].AverageRating}}</b> <span class="custom-text-color">Average Rating </span>
                        </span> 
                        <span>
                            <b class="count-rating mr-2">{{item[0].JSon9.length}}</b> <span class="custom-text-color">Review</span>
                        </span>    
                    </div>
                </div>
                
                    <span v-for="review in item[0].JSon9" :key="review.id">
                <div class="row">
                    <div class="col-md-12">
                        <hr/>
                    </div>
                </div>
                <div class="row pt-3">
                    <div class="col custom-text-color customer-name">
                        <a ><img v-bind:src="review.ReviewerImageURL" class="img-fluid rounded-circle mr-3" height="35px" width="35px" alt="Responsive image"><b>{{review.ReviewerName}}</b></a>
                    </div>
                    <div class="col text-right">
                        <span class="custom-text-color" v-for="stars in Math.floor(review.StarRating)" :key="stars.id">
                            <i class="fa fa-2x fas fa-star mr-2"></i>
                        </span>
                        <span class="custom-text-color" v-if="(review.StarRating % 1) != 0">
                            <i class="fa fa-2x fas fa-star-half mr-2"></i>
                        </span>
                        <span>{{review.StarRating}}</span>
                    </div>
                </div>
                <div class="row rating-padding">
                    <div class="col-md-12">
                        <span class="comment-content">{{review.Review}}</span>
                    </div>
                    <div class="col-md-12 pt-2">
                        <span v-if="review.HowGood == 'P'"><i class="fas fa-thumbs-up text-success mr-2"></i><small>POSITIVE</small></span>
                        <span v-if="review.HowGood == 'Ne'"><i class="fas fa-hand-point-up text-warning mr-2"></i><small>NEUTRAL</small></span>
                        <span v-if="review.HowGood == 'N'" class="align-middle"><i class="fas fa-thumbs-down text-danger mr-2 mt-2"></i></span><span class="align-middle"><small>NEGATIVE</small></span>
                    </div>
                    <div class="col-md-12 custom-text-color" >
                        <a  class="mr-3"><small><b>{{review.SelectedValuesCSV}}</b></small></a>
                        
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <hr/>
                    </div>
                </div>
                    </span>
                
            </div>

            
        <div class="modal fade" id="reviewRating" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h6 class="modal-title custom-text-color" id="exampleModalLongTitle"><b>Write A Review</b></h6>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"><img src="../assets/img/Icon material-cancel.svg" class="img-fluid"></span>
                </button>
            </div>
            <div class="modal-body">
                <form method="post" action="" enctype="multipart/form-data" id="myform">
                    <div class="row modal-rating-background pt-2">
                        <div class="col-md-12 text-center">
                            <span><b>How Was Your Experience ?</b></span>
                        </div>
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col pr-0">
                                    <fieldset class="rating"> 
                                        <input type="radio" id="star5" name="rating" value="5.0" /><label class="full" for="star5" title="Awesome - 5 stars"></label> 
                                        <input type="radio" id="star4half" name="rating" value="4.5" /><label class="half" for="star4half" title="Pretty good - 4.5 stars"></label> 
                                        <input type="radio" id="star4" name="rating" value="4.0" /><label class="full" for="star4" title="Pretty good - 4 stars"></label> 
                                        <input type="radio" id="star3half" name="rating" value="3.5" /><label class="half" for="star3half" title="Meh - 3.5 stars"></label> 
                                        <input type="radio" id="star3" name="rating" value="3.0" /><label class="full" for="star3" title="Meh - 3 stars"></label> 
                                        <input type="radio" id="star2half" name="rating" value="2.5" /><label class="half" for="star2half" title="Kinda bad - 2.5 stars"></label> 
                                        <input type="radio" id="star2" name="rating" value="2.0" /><label class="full" for="star2" title="Kinda bad - 2 stars"></label> 
                                        <input type="radio" id="star1half" name="rating" value="1.5" /><label class="half" for="star1half" title="Meh - 1.5 stars"></label> 
                                        <input type="radio" id="star1" name="rating" value="1.0" /><label class="full" for="star1" title="Sucks big time - 1 star"></label> 
                                        <input type="radio" id="starhalf" name="rating" value="0.5" /><label class="half" for="starhalf" title="Sucks big time - 0.5 stars"></label> 
                                        <input type="radio" class="reset-option" name="rating" value="reset" /> 
                                    </fieldset>
                                </div>
                                <div class="col-4 rating-output mt-2">
                                    <span><b class="myratings">0.0</b></span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 custom-text-color pt-3">
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" id="customCheck1">
                                <label class="custom-control-label checkbox-label" for="customCheck1"><b>Taste</b></label>
                            </div>
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" id="customCheck2">
                                <label class="custom-control-label checkbox-label" for="customCheck2"><b>Quality</b></label>
                            </div>
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" id="customCheck3">
                                <label class="custom-control-label checkbox-label" for="customCheck3"><b>Value For Money</b></label>
                            </div>
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" id="customCheck4">
                                <label class="custom-control-label checkbox-label" for="customCheck4"><b>Ambience</b></label>
                            </div>
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" id="customCheck5">
                                <label class="custom-control-label checkbox-label" for="customCheck5"><b>Staff Friendliness</b></label>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 pt-3 pb-3">
                            <b>Write your review</b>
                        </div>
                        <div class="col-md-12 text-muted">
                            <textarea class="form-control prepend-background border-0 text-muted" rows="5" placeholder="Review must be 100 characters in length"></textarea>
                        </div>
                        <div class="col-md-12 pt-3">
                            <b>Add Photos</b>
                        </div>
                        <div class="col-md-12 pt-2 pb-3">
                            <span class="btn btn-lg prepend-background fileinput-button">
                                <span><i class="fa fa-2x fas fa-camera p-2"></i></span>
                                <input type="file" name="files[]" id="files" multiple onchange="preview_image();"><br />
                            </span>
                            <div id="image_preview">
                                <div class="row">
                                    <!-- <div class="col-md-3 mt-3">
                                        <div class="card border-0">
                                            <img class="card-img" src="./assets/img/review-rating/image 17.svg" alt="Card image">
                                            <div class="card-img-overlay image-cross-icon p-0">
                                                <button type="button" class="close" aria-label="Close">
                                                    <span aria-hidden="true"><img src="./assets/img/Icon material-cancel.svg" class="img-fluid"></span>
                                                </button>
                                            </div>
                                        </div>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <button type="submit" class="btn btn-block custom-background-color "><i class="fas fa-check-circle mr-3"></i><span class="comment-content">Submit your review</span></button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

        </div>

</template>

<script>
export default {
  
  data : function(){
      return {
          storeName : sessionStorage.getItem('StoreName'),
          address : sessionStorage.getItem('StoreAddress'),
      }
  },
   filters: {
      sectionFilter: function(string){
          if(string.includes(',')){
              return string.split(',')
          }
          return string
      }
  },
   computed:{
      items() {
        return this.$store.state.items
      }
    },
  methods: {
      backToStore: function(){
          this.$router.go(-1);
      }
  },
 
    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
